import { render, staticRenderFns } from "./PrescribersList.vue?vue&type=template&id=3a1c9b37&scoped=true"
import script from "./PrescribersList.vue?vue&type=script&lang=js"
export * from "./PrescribersList.vue?vue&type=script&lang=js"
import style0 from "./PrescribersList.vue?vue&type=style&index=0&id=3a1c9b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c9b37",
  null
  
)

export default component.exports